define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query",
	"WBS/MilestoneReportMixin",
	"WBS/ReportTableMixin"
], function(declare, Widget, xml, Query, MilestoneReportMixin, ReportTableMixin) {

	return declare([Widget, MilestoneReportMixin, ReportTableMixin], {
		_resolveView() {
			// Yuriy says that making the type clause first helps query performance on Oracle
			var q = new Query();
			this._addTypeClause(q);
			q.RefAttr(this.getViewNodeReferenceAttrName(), xml.OP_EQUALS, this.getViewURL());
			this.relRoot.addQuery(q);
			this.inherited(arguments);
		}
	});
});